import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	alpha,
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import {
	AppThemeColor,
	ButtonSize,
} from '@app/enumerations';
// Import props.
import {
	InputButtonProps,
} from '@app/props';
// Import services.
import {
	StylesService,
} from '@app/services';

const useStyles = makeStyles((theme: Theme) => {

	return createStyles({
		inputButton_label: {
			width: (props: InputButtonProps) => (props.fullWidth ?? false) ? '100%' : 'auto',
		},
		inputButton_button: {
			width: (props: InputButtonProps) => (props.fullWidth ?? false) ? '100%' : 'auto',
			backgroundColor: (props: InputButtonProps) => StylesService.getInstance().getThemeColor(theme, props.buttonType ?? AppThemeColor.PRIMARY),
			color: (props: InputButtonProps) => StylesService.getInstance().getThemeColorContrastText(theme, props.buttonType ?? AppThemeColor.PRIMARY),
			height: (props: InputButtonProps) => StylesService.getInstance().getButtonSize(props.size ?? ButtonSize.MEDIUM),
			'&:hover': {
				transition: `${theme.transitions.duration.standard}ms ease-in-out`,
				backgroundColor: (props: InputButtonProps) => alpha(StylesService.getInstance().getThemeColor(theme, props.buttonType ?? AppThemeColor.PRIMARY), .8),
			},
		},
		inputButton_buttonDisabled: {
			background: (props: InputButtonProps) => alpha(StylesService.getInstance().getThemeColor(theme, props.buttonType ?? AppThemeColor.PRIMARY), .3),
			color: (props: InputButtonProps) => `${StylesService.getInstance().getThemeColorContrastText(theme, props.buttonType ?? AppThemeColor.PRIMARY)} !important`,
		},
	});
});

export default useStyles;
